import { useAuth } from "@/contexts/auth";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

const PricingFAQ = () => {
  const { t } = useTranslation('pricing');
  const { user } = useAuth();

  const faqItems = [
    {
      question: t('faq.howToStart'),
      answer: !user 
        ? t('faq.howToStartAnswer')
        : t('faq.howToStartAnswerLoggedIn')
    },
    {
      question: t('faq.howToUpgrade'),
      answer: user 
        ? t('faq.howToUpgradeAnswer')
        : t('faq.howToUpgradeAnswerGuest')
    },
    {
      question: t('faq.canCancel'),
      answer: t('faq.canCancelAnswer')
    },
    {
      question: t('faq.paymentMethods'),
      answer: t('faq.paymentMethodsAnswer')
    },
    {
      question: t('faq.tierDifference'),
      answer: t('faq.tierDifferenceAnswer')
    }
  ];

  return (
    <section className="border-y border-brand-cloud bg-white px-4 py-14 md:py-20">
      <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-[minmax(0,0.33fr)_minmax(0,0.67fr)] lg:gap-14">
        <div>
          <h2
            className="font-heading text-[length:var(--text-h2)] font-semibold text-brand-ink"
          >
            {t('faq.title')}
          </h2>
        </div>

        <Accordion type="single" collapsible className="divide-y divide-brand-cloud">
          {faqItems.map((item, index) => (
            <AccordionItem key={item.question} value={`faq-${index}`} className="border-0">
              <AccordionTrigger className="py-5 text-left font-heading text-h3 font-semibold text-brand-ink hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-7 text-brand-slate">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default PricingFAQ;
